import { Api } from '@blink/components';

export enum MemberRole {
    ADMIN = 'admin',
    MEMBER = 'member',
}

export enum MemberStatus {
    ACTIVE = 'active',
    PENDING = 'pending',
    ERROR = 'error',
    DELETED = 'deleted',
}

export type Me = {
    name: string;
    organization: {
        id: number;
        name: string;
    };
    email: string;
};

export type Member = {
    name: string;
    email: string;
    role?: MemberRole;
    status?: MemberStatus;
    lastActive?: string;
    lastSeen?: string;
};

export const getMe = () => {
    return Api.getResponse<Me>(`${Api.REACT_APP_ANALYTICS_HTTP_URL}/v1/me`);
};

export const getOrganizationMembers = ({ id }: { id: string }) => {
    return Api.getResponse<Member[]>(
        `${Api.REACT_APP_ANALYTICS_HTTP_URL}/v1/organizations/${id}/users`,
    );
};

export const postInviteMembers = ({ id, body }: { id: number; body: Member[] }) => {
    const stringifyId = id.toString();
    return Api.postResponse<any>(
        `${Api.ARKIS_PORTAL_HTTP_URL}/v1/organizations/${stringifyId}/users`,
        body,
    );
};

export const postResendInvite = ({ id, body }: { id: number; body: Member[] }) => {
    const stringifyId = id.toString();
    return Api.postResponse<any>(
        `${Api.ARKIS_PORTAL_HTTP_URL}/v1/organizations/${stringifyId}/users/invitations`,
        body,
    );
};
